'use client'
import React from 'react'
import CountryLanguage from './countryLanguage'

import styles from '../Header.module.scss'

const LoginRight = ({ countryKey }) => {
  return (
    <div className={styles.countryItem}>
      <CountryLanguage countryKey={countryKey} />
    </div>
  )
}

export default LoginRight
